import { render, staticRenderFns } from "./FloatingSidebar.vue?vue&type=template&id=12a43c34&scoped=true"
import script from "./FloatingSidebar.vue?vue&type=script&lang=js"
export * from "./FloatingSidebar.vue?vue&type=script&lang=js"
import style0 from "./FloatingSidebar.vue?vue&type=style&index=0&id=12a43c34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a43c34",
  null
  
)

export default component.exports